import React, { Component } from "react";
import { apiCall_domain } from "../api";
import axios from "axios";
import AddCars from "./AddCars";
import { Link } from "react-router-dom";
import Spinner from "../Spinner/Spinner";

export default class UsersCar extends Component {
  state = {
    deleteCarId: "",
    DataMyCar: "",
    selectedValue: "",
    cars: [],
    loading: true,
    ShowCar: false,
  };

  componentDidMount() {
    this.getCars();
  }
  getCars = () => {
    this.setState({ loading: true }, () => {
      const headers = {
        Authorization: localStorage.getItem("Api_key"),
        "content-type": "application/json",
      };

      axios
        .get(`${apiCall_domain}/customer/user/cars`, {
          headers,
        })
        .then((res) => {
          this.setState({ cars: res.data.data, loading: false });
        });
    });
  };

  render() {
    const deleteUsersCar = (id) => {
      const headers = {
        Authorization: localStorage.getItem("Api_key"),
        "content-type": "application/json",
      };
      const Data = {
        id: id,
      };

      this.setState({ deleteCarId: id });

      axios
        .post(`${apiCall_domain}/customer/user/cars/delete`, Data, {
          headers: headers,
        })
        .then((res) => {
          this.getCars();
          localStorage.setItem("carId2", "");
        })

        .catch(function (error) {
          if (error.response.status === 463) {
            window.location.reload(false);
          }
        });
    };
    const myCarSearch = (item) => {
      const data = {
        brand: { id: item.car.car_brand_id, name: item.car.brand },
        car: { id: item.car.car_model_type_id, name: item.car.name },
        type: item.car.car_type_id,
      };

      localStorage.setItem("data", JSON.stringify(data));
      this.props.props.history.push({
        pathname: "/categories/3",
      });
    };

    return (
      <main>
        {this.state.loading ? (
          <Spinner />
        ) : (
          <>
            <Link to={"/Search/addCars"} className='AddCar'>
              <img src='/public/assets/icons/add-square.svg' alt='pictuer' />
              <span>افزودن خودرو</span>
            </Link>
            {this.state.cars.map((item) => (
              <div className='usersCar'>
                <div className='myCarSearch' onClick={() => myCarSearch(item)}>
                  <div className='carsBrand'>
                    <span className='name'>{item.car.name}</span>
                    <span className='brand'>({item.car.brand})</span>
                  </div>
                  <div className='carsBrand'>
                    <span className='type'>تیپ : {item.car.type}</span>
                  </div>
                </div>
                <div className='carsBrand mycar'>
                  <span className='myCarsName'>{item.name}</span>
                  <span className='deleteCar'>
                    <span
                      className='btn btn--remove'
                      onClick={(e) => deleteUsersCar(item.id)}>
                      حذف خودرو
                    </span>
                  </span>
                </div>
              </div>
            ))}
          </>
        )}
        {this.state.ShowCar ? <AddCars /> : null}
      </main>
    );
  }
}
